import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../services/apiConfig';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';
import PublicLayout from '../components/public/PublicLayout';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true); // Optional: show loading state

        try {
            const response = await axios.post(`${API_BASE_URL}/login.php`, {
                email,
                password
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Login Response:', response);

            if (response.data.status === 'success') {
                // Store token in localStorage
                localStorage.setItem('token', response.data.token);

                // Redirect to the dashboard
                window.location.href = "/dashboard";
            } else {
                // Show error message if login fails
                setMessage(response.data.message || 'Login failed.');
            }
        } catch (error) {
            // Catch and log any errors
            setMessage('An error occurred. Please try again.');
            console.error('Error logging in:', error);
        } finally {
            setLoading(false); // Hide loading state
        }
    };


    return (
        <PublicLayout title="Staff sign in | Horizont Medical Center">
            <section className="hc-container hc-login" aria-labelledby="login-heading">
                <div className="hc-login-intro">
                    <p className="hc-eyebrow"><span /> FOR THE HORIZONT TEAM</p>
                    <h1 id="login-heading">Welcome back.<br /><span>Your day starts here.</span></h1>
                    <p>Sign in to your Horizont Clinic workspace using your existing staff account.</p>
                    <div className="hc-login-note"><FiLock aria-hidden="true" /><span>Staff access · Clinic management system</span></div>
                </div>
                <div className="hc-login-card">
                    <h2>Staff sign in</h2>
                    <p>Enter your email and password to continue.</p>
                    <form onSubmit={handleSubmit} className="hc-login-form" aria-busy={loading}>
                        <TextField
                            fullWidth
                            type="email"
                            id="email"
                            name="email"
                            autoComplete="username"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            label="Email"
                            variant="outlined" />
                        <TextField
                            fullWidth
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            label="Password"
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            type="button"
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                            aria-pressed={showPassword}
                                            onClick={() => setShowPassword(p => !p)}
                                            edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }} />
                        <Button color="primary" type="submit" size="large" disabled={loading} variant="contained">
                            {loading ? 'Logging in...' : 'Login'}
                        </Button>
                        {message && <p className="hc-login-message" role="alert">{message}</p>}
                    </form>
                    <Link to="/" className="hc-login-back">Back to Horizont Clinic</Link>
                </div>
            </section>
        </PublicLayout>
    );
};

export default Login;
